module.exports = __webpack_public_path__ + "img/11.full.ea6a4073.webp";